export const NAV_EVENT = {
  INITIALIZED: "initialized",
  NEXT_CLICKED: "next_clicked",
  PREVIOUS_CLICKED: "previous_clicked",
  GO_TO_ACTIVE_STEP: "go_to_active_step",
  VISIT_QUOTES: "visit_quotes",
  VISIT_NAME: "visit_name",
  BROWSER_NAV: "browser-nav"
};

export type NavEvent = (typeof NAV_EVENT)[keyof typeof NAV_EVENT];
